import moment from 'moment';

const DATE_FORMATS = [
    'YYYY-MM-DD',
    'YYYYMMDD',
    'DD/MM/YYYY',
    'YYYY-MM-DD HH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss.SSSZ',
    'YYYY-MM-DDTHH:mm:ssZ',
    'DD/MM/YYYY HH:mm',
    'DD/MM/YYYY HH:mm:ss'
];

const parseDate = (value) => {
    if (!value) {
        return null;
    }

    const text = `${value}`.trim();

    if (!text) {
        return null;
    }

    const strictMatch = moment(text, DATE_FORMATS, true);

    if (strictMatch.isValid()) {
        return strictMatch;
    }

    const fallbackMatch = moment(text);
    return fallbackMatch.isValid() ? fallbackMatch : null;
};

const formatDateDisplay = (value, fallback = '-') => {
    const parsed = parseDate(value);
    return parsed ? parsed.format('DD/MM/YYYY') : fallback;
};

const formatDateTimeDisplay = (value, fallback = '-') => {
    const parsed = parseDate(value);
    return parsed ? parsed.format('DD/MM/YYYY HH:mm') : fallback;
};

const formatDateForInput = (value, fallback = '') => {
    const parsed = parseDate(value);
    return parsed ? parsed.format('YYYY-MM-DD') : fallback;
};

export {
    formatDateDisplay,
    formatDateForInput,
    formatDateTimeDisplay
};
